import Vue from 'vue'
import Router from 'vue-router'
import jobShow from '@/pages/jobShow/index'
import selectCity from '@/pages/jobShow/selectCity'
import inTheCity from '@/pages/jobShow/inTheCity'
import labourDetail from '@/pages/jobShow/labourDetail'
import downloadApp from '@/pages/downloadApp/index'
import relationPages from '@/pages/relationPages/index'
import investment from '@/pages/investment/index'
import newsDynamic from '@/pages/newsDynamic/index'
import newDetail from '@/pages/newsDynamic/newDetail'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      meta:{
        title:'好工网',
      },
      name: 'jobShow',
      component: jobShow,
    },
    {
      path:'/inTheCity/:id',
      name:'inTheCity',
      component:inTheCity
    },
    {
      path:'/selectCity',
      name:'selectCity',
      component:selectCity
    },
    {
      path:'/labourDetail',
      name:'labourDetail',
      component:labourDetail
    },
    {
      path:'/downloadApp',
      name:'download',
      component:downloadApp
    },
    {
      path:'/relationPages',
      name:'relationPages',
      component:relationPages
    },
    {
      path:'/investment',
      name:'investment',
      component:investment
    },
    {
      path:'/newsDynamic',
      name:'newsDynamic',
      component:newsDynamic,
    },
    { 
      path:'/newDetail/:id',
      name:'newDetail',
      component:newDetail
    },
  ]
})
router.beforeEach((to, form, next) => {
  // 如果有token 说明该用户已登陆
  if(to.meta.title){
    document.title = to.meta.title
  }
    next()
})

export default router
